module.exports = __webpack_public_path__ + "static/media/New_Series_3_Ep2_You_are_what_your_food_eats_Desktop.84d37b7b.jpg";